package com.dwarshb.bms

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material3.CardDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.unit.dp

@Composable
fun BusTicketReservation(viewModel: BookingViewModel) {
    var origin by remember { mutableStateOf("") }
    var destination by remember { mutableStateOf("") }
    val selectedSeats by viewModel.selectedSeats.collectAsState()
    var formStagees by remember { mutableStateOf(0) }
    Column(
        modifier = Modifier.fillMaxSize().padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
//        Card {
//            Image(
//                contentDescription = "",
//                modifier = Modifier.fillMaxWidth(),
//                bitmap = viewModel.getBusBanner() )
//        }
        Card(
            elevation = CardDefaults.cardElevation(16.dp),
            shape = RoundedCornerShape(16.dp)) {
            if (formStagees == 0) {
                // Origin and Destination Dropdowns
                Column(modifier = Modifier.padding(8.dp)) {
                    CustomDropdownMenu(
                        modifier = Modifier.fillMaxWidth(),
                        viewModel.cities, "Origin", origin
                    ) { origin = it }
                    CustomDropdownMenu(
                        modifier = Modifier.fillMaxWidth(),
                        viewModel.cities, "Destination", destination
                    ) {
                        destination = it
                    }
                    Button(modifier = Modifier.fillMaxWidth(), onClick = { formStagees++ }) {
                        Text("Next Step")
                    }
                }
            } else if (formStagees == 1) {
                Column {

                    // Seat Selection
                    Row {
                        IconButton(onClick = { formStagees-- }) {
                            Icon(Icons.AutoMirrored.Default.ArrowBack, contentDescription = "")
                        }
                        Text(
                            "Select Seats", style = MaterialTheme.typography.bodyMedium,
                            modifier = Modifier.align(Alignment.CenterVertically)
                        )
                    }
//                    SeatLayout(seats = viewModel.seats, selectedSeats, onSeatSelected = {
//                        viewModel.selectSeat(it)
//                    })
                    Button(modifier = Modifier.fillMaxWidth(), onClick = { formStagees++ }) {
                        Text("Next Step")
                    }
                }

            } else if (formStagees == 2) {
                Column {

                    // Passenger Details
                    if (selectedSeats.isNotEmpty()) {
                        Row {
                            IconButton(onClick = { formStagees-- }) {
                                Icon(Icons.AutoMirrored.Default.ArrowBack, contentDescription = "")
                            }
                            Text(
                                "Passenger Details", style = MaterialTheme.typography.bodyMedium,
                                modifier = Modifier.align(Alignment.CenterVertically)
                            )
                        }
                        PassengerDetailsForm(viewModel)
                    }
                    Row {
                        Button(onClick = { formStagees++ }) {
                            Text("Next Step")
                        }
                    }
                }
            } else {

                // Transaction Upload
//        TransactionUpload(viewModel)

                // Submit Button
                Button(
                    onClick = { viewModel.submitBooking(origin, destination) },
                    enabled = viewModel.transactionScreenshot != null
                ) {
                    Text("Book Tickets")
                }
            }
        }
    }
}

@Composable
fun CustomDropdownMenu(
    modifier: Modifier,
    items: List<String>,
    label: String,
    selected: String,
    onSelected: (String) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }

    Box(modifier) {
        OutlinedTextField(
            modifier = modifier.onFocusChanged { expanded = it.isFocused },
            value = selected,
            onValueChange = {},
            label = { Text(label) },
            readOnly = true,
            trailingIcon = {
                IconButton(onClick = { expanded = true }) {
                    Icon(Icons.Default.ArrowDropDown, contentDescription = "dropdown")
                }
            }
        )
        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false }
        ) {
            items.forEach { item ->
                DropdownMenuItem(
                    text = {Text(item)},
                    onClick = {
                        onSelected(item)
                        expanded = false
                })
            }
        }
    }
}